/* src/app/components/payroll/authorizations/authorization-details/authorization-details.component.css */
.ppl-mb24 {
  margin-bottom: 24px !important;
}
/*# sourceMappingURL=authorization-details.component-FGPHLXXH.css.map */
